import { render, staticRenderFns } from "./actual.vue?vue&type=template&id=623d1b41&"
import script from "./actual.vue?vue&type=script&lang=js&"
export * from "./actual.vue?vue&type=script&lang=js&"
import style0 from "./actual.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports